import "./index.scss";

export default function Cabecalho() {
  return (
    <>
      <div className="container-cabecalho">
        <img src="/assets/images/logoo.png" alt="" className="container-logo" />



        <ul className="lista">
          <li className="lista-item">
            <a href="https://www.instagram.com/espacoahdora/">Quem Somos</a>
          </li>
          <li className="lista-item">
            <a href="https://maps.app.goo.gl/RDobDRrEcgQJZLmD7">Localização</a>
          </li>
          <li className="lista-item">
            <a href="https://www.google.com/search?client=opera-gx&sca_esv=9e7358a0bf207c7d&authuser=1&sxsrf=AHTn8zoYAHE0kZi6PJgd9k2P7ZheiZHiRQ:1742082442015&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzVyn2FsFySwZ8Yn9qJO4lekqZGPoDjrRItf3_5uxRY5jTKYMtzirem6Z5kS4hQ5FlN3H6h8ANVeBg9vpZkknUN1Ek5XU4c6UMwhxve19Kwiv6lKKcbYws2W-odPzeY2FPew3Ecns635uuFd-w11OjSo3N5_B&q=Espa%C3%A7o+Ahdora+-+Beleza,+Sa%C3%BAde+e+Bem-Estar+Coment%C3%A1rios&sa=X&ved=2ahUKEwi6voDpoo2MAxVgrJUCHeFeBdMQ0bkNegQIKBAE&biw=1493&bih=794&dpr=1">Nos Avalie</a>
          </li>
          <li className="lista-item">
            <a href="https://wa.me/5511980432650">Contato</a>
          </li>
        </ul>
      </div>
    </>
  );
}
